<template>
	<div class="flex flex-col">
		<div>
			<div class="m-4" v-if="this.processes && this.processes.length <= 0">
				<b>{{ $t('no_processes') }}</b>
			</div>
			<div
				class="align-middle inline-block min-w-full shadow overflow-hidden border-b border-gray-200 rounded"
				v-if="this.processes && this.processes.length > 0"
			>
				<table class="min-w-full">
					<thead class="w-full" style="height: fit-content;">
						<tr class="w-full">
							<HeaderColumn class="w-3/12" style="width: fit-content">{{ $t('vehicle') }}</HeaderColumn>
							<HeaderColumn class="w-2/12">{{ $t('license_plate') }}</HeaderColumn>
							<HeaderColumn class="pl-6 4/12">{{ $t('customer') }}</HeaderColumn>
							<HeaderColumn class="pl-6 w-3/12">{{ $t('process_type') }}</HeaderColumn>
						</tr>
					</thead>
					<tbody class="bg-white">
						<tr v-for="process in this.processes" :key="process.id" class="tr odd:bg-gray-200 cursor-pointer" @click="editModel(process)">
							<td class="px-6 py-4 border-b border-gray-200 w-3/12">{{ process.vehicle.manufacturer }} {{ process.vehicle.model }}</td>
							<td class=" py-4 border-b border-gray-200 w-2/12">
								{{ process.vehicle.licensePlate.text }}
							</td>
							<td class="pl-6 py-4 border-b border-gray-200 w-4/12">
								{{ process.customer.gender === 'company' ? 'Firma ' + process.customer.companyName : process.customer.lastName }}
								<div style="font-size: 13px">
									{{ getSystemNumber(process) }}
								</div>
							</td>
							<td class="pl-6 py-4 border-b border-gray-200 w-3/12 pr-16">
								{{ getProcessLabel(process) }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { getStringFromDate } from '@/plugins/Utils';
import HeaderColumn from '@/components/columns/HeaderColumn.vue';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'DashboardProcessList',
	components: { HeaderColumn },
	mixins: [Authentication],
	props: {
		processes: { required: true },
	},
	methods: {
		getProcessLabel(process) {
			switch (process.processType) {
				case 'liability':
					return this.$t('liability_short');
				case 'comprehensive':
					return this.$t('comprehensive_short');
				case 'order_documentation':
					return this.$t('order_documentation') + ' (' + process.orderDocumentationType.name + ')';
				default:
					return this.$t('general_title');
			}
		},
		getSystemNumber(process) {
			if (this.isUserAllowedInLevel2) {
				return process.damageAssessorReferenceNumber != null ? `( ${process.damageAssessorReferenceNumber} )` : '';
			}
			if (this.isUserAllowedInLevel5or6) {
				return process.repairShopReferenceNumber != null ? `( ${process.repairShopReferenceNumber} )` : '';
			}
			if (this.isUserAllowedInLevel3) {
				return process.lawyerOfficeReferenceNumber != null ? `( ${process.lawyerOfficeReferenceNumber} )` : '';
			}
		},
		getStringFromDate,
		editModel(row) {
			this.$router.push({ name: 'management.process.edit', params: { customer: row.customer.id, processId: row.id } });
		},
	},
};
</script>
